import React from "react";

function UpcomingSchedules() {
  return (
    <div className="upcoming-schedules-main project-view-summary-sec-main">
      <div className="summary-title">
        <h3>Upcoming Schedules</h3>
      </div>
      <div className="all-upcoming-schedules">
        <div className="single-upcoming-schedules">
          <div className="single-upcoming-schedules-inner">
            <p>Schedule Time</p>
            <h6>14:00</h6>
          </div>
          <div className="single-upcoming-schedules-inner">
            <p>Schedule On</p>
            <div>
              <p>January, June, August <b>(Monday,Wednesday,Friday)</b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpcomingSchedules;
